import React from "react";
import Router from "next/router";
import { Tabs, Empty, Spin, Pagination } from "antd";
import { getPromotionCategories, manualPromotionEnrollment } from "$ACTIONS/promotionRequest";
import { PromotionDetail, GetAssignedClaimsList } from "$ACTIONS/cmsApi";
import { connect } from "react-redux";
import { promotionActions } from "$STORE/promotionSlice";
import { getPromotionListAction } from "$STORE/thunk/promotionThunk";
import { getBalanceInfoAction } from "$STORE/thunk/balanceThunk";
import { advget } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import ImageWithFallback from "@/ImageWithFallback/";
import DetailModal from "@/Promotion/Detail";
import { ManualModal, BonusModal } from "@/MyPromotionTabs/Modal";
import showPromotionErrorModal from "@/Promotion/UI";
import moment from "moment";
import { showResultPopup } from "$ACTIONS/helper";
import showMessage from "$ACTIONS/messageUtil";
import { getPromotionStatus } from "@/Promotion/PromotionStatusButton";
import classNames from "classnames";
import StartPromotionModal from "@/MyPromotionTabs/NotStarted/StartPromotionModal";
import { checkUserSelfExclusion } from "$ACTIONS/selfExclusionHelper";
const { TabPane } = Tabs;

class PromotionTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //所需基本資料
            filterdata: this.props.promotions, //依產品類別篩選好的Promotion item
            selectedPromotionItem: null, //所點選 Promotion item
            selectedPromotionDetail: null, //所選 Promotion詳細內容
            startPromotionData: null, //所選 startPromotion item

            //Modal Open 相關
            isPromotionDetailModalVisible: false, //是否顯示優惠詳情 Modal
            isManualApplyModalVisible: false, //是否顯示 Manual 申請 Modal
            isBonusModalVisible: false, //是否顯示 Bonus 申請彈窗
            isStartModalVisible: false, //是否顯示 開始優惠 彈窗

            //資料顯示狀態判斷
            isPromotionDetailLoading: false,
            Tabkey: "0", //左側Tab選單index (Start from 0, 各產品category)
            pageIndex: 1,
        };

        this.getCategories = this.getCategories.bind(this); //获取全优惠分类
        this.openPromotionDetailHandler = this.openPromotionDetailHandler.bind(this); //開啟優惠詳細的handler
    }

    componentDidMount() {
        /* 获取全优惠分类 */
        this.getCategories();
        /* 获取 Promotion List */
        this.props.setPromotions();
        //由首頁banner點擊跳轉進
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("id");
        const jumpfrom = urlParams.get("jumpfrom");
        if (id && jumpfrom) {
            const item = {
                promoId: id,
            };
            // 開啟優惠詳細
            this.openPromotionDetailHandler(item, jumpfrom);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        //關閉詳情彈窗，清除 redux selectedBonus data
        if (
            prevState.isPromotionDetailModalVisible !==
                this.state.isPromotionDetailModalVisible &&
            !this.state.isPromotionDetailModalVisible
        ) {
            this.props.setSelectedBonus(null);
            this.setState({
                selectedPromotionDetail: null,
                selectedPromotionItem: null,
            });
            this.removeQueryString();
        }
        //當 Promotions List 刷新
        if (prevProps.promotions !== this.props.promotions) {
            //如果有選取的 selectedPromotionItem，刷新 selectedPromotionItem
            const newSelectedPromotionItem = this.state.selectedPromotionItem
                ? this.props.promotions.find(
                    (item) => item.promoId === this.state.selectedPromotionItem.promoId
                )
                : null;

            this.setState({
                selectedPromotionItem: newSelectedPromotionItem,
            });

            this.callback(this.state.Tabkey, true);
        }
        //登入後，刷新 Promotion List
        if (
            prevProps.memberInfo?.memberCode !==
            this.props.memberInfo?.memberCode
        ) {
            this.props.setPromotions();
        }
        //在存款成功頁面，點擊"返回優惠頁"按鈕 >> 關閉詳情彈窗、刷新 Promotions List
        if (
            prevProps.backPromotionPage !== this.props.backPromotionPage &&
            this.props.backPromotionPage
        ) {
            this.props.setBackPromotionPage(false);
            this.setState({
                isPromotionDetailModalVisible: false,
            });
            this.props.setPromotions();
        }
    }

    componentWillUnmount() {
        this.props.setSelectedBonus(null);
    }
    /**
     * @description: 获取优惠分类
     * @return {*}
     */
    async getCategories() {
        const res = await getPromotionCategories();
        if (res && res.length > 0) {
            //篩選出需show在左邊Menu的item
            const categories = res.filter(
                (item) => item.parentName === "General"
            );
            const all = {
                PromoCatID: "",
                PromoCatCode: "All",
                resourcesName: "ทั้งหมด", //全部
                promoCatImageUrl: "/th/img/promotions/icon/icon-all.png",
                parentId: "",
                parentName: "General",
            };
            this.props.setCategories([all, ...categories]);
        }
    }
    //開啟優惠詳細的handler
    openPromotionDetailHandler(item, jumpfrom) {
        console.log("openedItem: activeItem", item);
        this.setState({
            selectedPromotionItem: item,
            isPromotionDetailLoading: true,
            isPromotionDetailModalVisible: true,
        });
        const params = {
            id: item.promoId,
            jumpfrom: jumpfrom,
        };
        //獲取Promotion Detail
        PromotionDetail(params).then((res) => {
            console.log("openedItem: detail", res);
            this.setState({ isPromotionDetailLoading: false });
            if (res) {
                (res.bonusMinAmount = parseInt(res.bonusMinAmount) || 0),
                    (res.bonusMaxAmount = parseInt(res.bonusMaxAmount) || 0);
                this.setState({
                    selectedPromotionDetail: res,
                });
            }
        });
    }
    // 點擊 TnC 按鈕
    actionBtnHandler = async (itemData, btnType) => {
        // piwik
        const gtagMapping = {
            readyToStart: {
                event: "Start Promotion",
                action: "Promotion_C_StartPromotion",
                variableKey: "Promotion_C_StartPromotion_PromoName_PrmoID",
                variableValue: `${itemData?.promoTitle}_${itemData?.promoId}`,
            },
            goApply: {
                event: "Apply Promotion",
                action: "Promotion_C_ApplyNow",
            },
        };
    
        if (gtagMapping[btnType]) {
            Pushgtagdata(
                "Promotion",
                gtagMapping[btnType].event,
                gtagMapping[btnType].action,
                false,
                gtagMapping[btnType].variableKey
                    ? [
                          {
                              customVariableKey: gtagMapping[btnType].variableKey,
                              customVariableValue: gtagMapping[btnType].variableValue,
                          },
                      ]
                    : []
            );
        }

        // 会员未登录
        if (!this.props.isLogin) {
            global.goUserSign("1");
            return;
        }

        // 会员登录信息未返回，不做任何操作
        if (JSON.stringify(this.props.memberInfo) == "{}") {
            return;
        }

        // 自我限制檢查
        const hasSelfExclusion = await checkUserSelfExclusion((status) => {
            this.setState({ isPromotionDetailLoading: status });
        }, "bonus");
        if (hasSelfExclusion) return;

        // 應用優惠
        if (btnType === "readyToStart") {
            const participantId = itemData?.campaignData?.participant?.id;

            if (!participantId) {
                showMessage("info", "can't find valid participantId", 80);
                return;
            }

            this.setState({ isPromotionDetailLoading: true });

            try {
                const res = await GetAssignedClaimsList(participantId);

                if (Array.isArray(res) && res?.length > 0) {
                    const item = res[0]; // 取出第一筆資料
                    this.setState({
                        startPromotionData: item,
                        isStartModalVisible: true,
                    });
                } else {
                    showMessage("info", `can't find participantId: ${participantId}`, 80);
                }
            } catch (error) {
                console.error("Error fetching promotion data:", error);
            } finally {
                this.setState({ isPromotionDetailLoading: false });
            }
        } else if (btnType === "goApply") {
            const { actionType } = itemData || {};
            switch (actionType) {
                case "APPLY_FORM":
                case "NO_FORM":
                    return this.applyManualPromotion(itemData);
                case "FUND_IN":
                case "DEPOSIT_PAGE_ONLY":
                    return this.applyReloadBonus(itemData);
                default:
                    return;
            }
        }
    };

    /**
     * @description: 申請 Manual Promotion
     * @param {object} itemData
     * @param {string} itemData.actionType - 申請類型，可選值：'APPLY_FORM' 或 'NO_FORM'
     * @param {object} itemData.campaignData
     * @return {*}
     */
    applyManualPromotion = async (itemData) => {
        const { campaignData, actionType } = itemData;
        const { id: entryPeriodId } = campaignData?.entryPeriod || {};
        const param = {
            entryPeriodId,
        };

        try {
            this.setState({ isPromotionDetailLoading: true });

            const eligibilityCheckResult = await manualPromotionEnrollment(1, param);
            if (eligibilityCheckResult?.isSuccess && eligibilityCheckResult?.result?.isSuccess) {
                if (actionType === "APPLY_FORM") {
                    this.setState({ isManualApplyModalVisible: true });
                } else if (actionType === "NO_FORM") {
                    const applyParam = {
                        entryPeriodId,
                        siteId: 37,
                        formData: {
                            formType: 6,
                        },
                    };
                    const res = await manualPromotionEnrollment(2, applyParam);
                    if (res?.isSuccess && res?.result?.isSuccess) {
                        showMessage("success", "สมัครโปรโมชั่นสำเร็จ", 80); //优惠申请成功
                        this.setState({
                            isPromotionDetailModalVisible: false,
                        });
                        this.props.setPromotions(); //刷新 Promotion List
                    } else {
                        const errorCode = res?.result?.errorCode;
                        const apiMessage = res?.result?.message;
                        //根據 Mockup 針對有 define 的 error 跳出 errorModal
                        return showPromotionErrorModal(errorCode, apiMessage);
                    }
                }
            } else {
                const errorCode = eligibilityCheckResult?.result?.errorCode;
                const apiMessage = eligibilityCheckResult?.result?.message;
                //根據 Mockup 會針對 CP30001, CP30002, CP30003 跳出 errorModal
                return showPromotionErrorModal(errorCode, apiMessage);
            }
        } catch (error) {
            console.error("applyManualPromotion error:", error);
        } finally {
            this.setState({ isPromotionDetailLoading: false });
        }
    };

    /**
	 * @description: 申請 Reload Bonus
	 * @return {*}
  	*/
    applyReloadBonus = async (itemData) => {
        if (!this.props.balanceInfo || this.props.isBalanceLoading) {
            console.error("数据加载中，请稍等。");
            showMessage("error", "กำลังโหลด กรุณารอสักครู่", 80);
            return;
        }

        try {
            this.setState({ isPromotionDetailLoading: true });
            //Promotion is available
            const res = await advget(
                `${ApiPort.GETBonusApplicationsEligible}&bonusGroupId=${itemData?.bonusData?.groupID}`
            );
            if (res?.isSuccess && res?.result?.isEligible) {
                if (
                    itemData.actionType === "DEPOSIT_PAGE_ONLY" ||
                    this.props.balanceInfo.MAIN.balance <
                        itemData?.bonusData?.minAccept
                ) {
                    // 儲存 redux selectedBonus data
                    this.props.setSelectedBonus(itemData);

                    // 餘額不足 Modal
                    showResultPopup({
                        type: "confirm",
                        title: "ยอดคงเหลือไม่เพียงพอ",
                        content:
                            "ยอดเงินในบัญชีไม่เพียงพอ กรุณาทำรายการฝาก",
                        okText: "ฝากตอนนี้",
                        cancelText: "ปิด",
                        onOk: () => {
                            global.showDialog({
                                key: 'wallet:{"type": "deposit"}',
                            });
                        },
                        onCancel: () => {},
                    });
                } else {
                    this.setState({
                        isBonusModalVisible: true,
                    });
                }
            } else {
                const errorCode = res?.result?.errorCode;
                const apiMessage = res?.result?.message;
                // 根據 Mockup 會針對 BP10011, BP10004, BP10017 跳出 errorModal
                return showPromotionErrorModal(errorCode, apiMessage);
            }
        } catch (error) {
            console.error("applyReloadBonus error:", error);
        } finally {
            this.setState({ isPromotionDetailLoading: false });
        }
    };

    /**
	 * @description: 關閉詳情彈窗，去除 query string
	 * @return {*}
  	*/
    removeQueryString = () => {
        if (
            Router.router.query.id &&
            Router.router.query.jumpfrom === "BANNER"
        ) {
            Router.push("/promotions", "/โปรโมชั่น", { shallow: true });
        }
    };

    callback = (key, isRefresh = false) => {
        if (!isRefresh) {
            Pushgtagdata(
                "Promotion",
                "Promotion Filter",
                "Promotion_C_Filter",
                false,
                [
                    {
                        customVariableKey: `Promotion_C_Filter_GameCategory`,
                        customVariableValue: `${this.props.categories[key].PromoCatCode}`,
                    },
                ]
            );
        }
        if (key === null || key === "0") {
            return this.setState((prevState) => ({
                filterdata: this.props.promotions,
                Tabkey: "0",
                pageIndex: isRefresh ? prevState.pageIndex : 1,
            }));
        }
        // 過濾數據，保留符合指定分類的項
        let filterdata = this.props.promotions.filter((item) =>
            item.category.includes(this.props.categories[key].PromoCatCode)
        );
        console.log("filterdata =====>", filterdata);
        this.setState((prevState) => ({
            filterdata: filterdata,
            Tabkey: key.toString(),
            pageIndex: isRefresh ? prevState.pageIndex : 1,
        }));
    }

    /**
     * 取得 Promotion list item
     * @param {*} item
     * @returns
     */
    renderPromotionItem = (item) => {
        const statusItem = getPromotionStatus(item);
        const { tagCN, tagText, isDisabled, isButtonStyle } = statusItem || {};

        return (
            <div className="content-box">
                <div className="item-list">
                    <div className="image-wrapper">
                        <ImageWithFallback
                            src={item.promoImage || "/th/img/logo.svg"}
                            width={288}
                            height={108}
                            alt={item.promoTitle}
                            fallbackSrc="/th/img/logo.svg"
                        />
                        {isDisabled && <div className="image-overlay"></div>}
                    </div>
                    <div className="text-box">
                        <div className="description">
                            <p className="title">{item.promoTitle}</p>
                            {tagText && (
                                <div
                                    data-cn={tagCN}
                                    className={classNames({
                                        statusTag: true,
                                        disabled: isDisabled,
                                        arrow: !isButtonStyle,
                                    })}
                                >
                                    {tagText}
                                </div>
                            )}
                        </div>
                        <div className="period">
                            <span>
                                <img src="/th/img/promotions/time.svg" />
                            </span>
                            <p>
                                {`${moment(item.startDate)
                                    .utcOffset(8)
                                    .format("DD/MM/YYYY HH:mm")} - ${moment(
                                    item.endDate
                                )
                                    .utcOffset(8)
                                    .format("DD/MM/YYYY HH:mm")} GMT+8`}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const {
            filterdata,
            Tabkey,
            selectedPromotionItem,
            selectedPromotionDetail,
            isPromotionDetailModalVisible,
            isManualApplyModalVisible,
            isBonusModalVisible,
            isStartModalVisible,
            pageIndex,
            isPromotionDetailLoading,
            startPromotionData,
        } = this.state;
        const { balanceInfo, isRefreshingPromotion } = this.props;

        return (
            <>
                {this.props.promotions != "" &&
                this.props.categories?.length != 0 ? (
                    <Tabs
                        tabPosition={"left"}
                        className="tlc-promotions-sidebar"
                        activeKey={Tabkey}
                        onChange={(e) => this.callback(e)}
                    >
                        {this.props.categories?.map((categoryItem, index) => (
                            <TabPane
                                tab={
                                    <div className="icon-list-wrapper">
                                        <div className={`icon-list ${Tabkey === index.toString() && "icon-list-active"}`}>
                                            <img
                                                className={`icon-image icon-image-active`}
                                                src={categoryItem.promoCatImageUrl}
                                                style={{
                                                    filter: "greyscale(1)",
                                                }}
                                            />
                                            {categoryItem.resourcesName}
                                        </div>
                                        {categoryItem?.tailImg && (
                                            <img alt="tailImg" style={{ height: 20 }} src={categoryItem.tailImg}/>
                                        )}
                                    </div>
                                }
                                key={index}
                            >
                                {/* 每項item (右半邊) */}
                                <div className="promotion-list-box">
                                    <Spin
                                        spinning={isRefreshingPromotion}
                                        tip="กำลังโหลด กรุณารอสักครู่..." //加载中，请稍后...
                                    >
                                        <ul className="Pms_data_list">
                                            {filterdata && filterdata.length ? (
                                                filterdata
                                                    .slice(
                                                        (pageIndex - 1) * 9,
                                                        pageIndex * 9
                                                    )
                                                    .map((item, key) => {
                                                        return (
                                                            <li
                                                                key={
                                                                    "pms-data-" +
                                                                    key
                                                                }
                                                                onClick={() => {
                                                                    this.openPromotionDetailHandler(
                                                                        item
                                                                    );
                                                                    let promoCat =
                                                                        categoryItem.PromoCatCode;
                                                                    switch (
                                                                        promoCat
                                                                    ) {
                                                                        case "New member":
                                                                            promoCat =
                                                                                "NewMember";
                                                                            break;
                                                                        case "Casino":
                                                                            promoCat =
                                                                                "LiveDealer";
                                                                            break;
                                                                        case "Slot":
                                                                            promoCat =
                                                                                "SlotFishing";
                                                                            break;
                                                                    }
                                                                    Pushgtagdata(
                                                                        "Promotion",
                                                                        "View Promo",
                                                                        "Promotion_V_Promotion",
                                                                        false,
                                                                        [
                                                                            {
                                                                                customVariableKey: `Promotion_C_${promoCat}_PromoName_PrmoID`,
                                                                                customVariableValue: `${item.promoTitle}_${item.promoId}`,
                                                                            },
                                                                        ]
                                                                    );
                                                                }}
                                                                className="promotion-item-box"
                                                            >
                                                                {this.renderPromotionItem(item)}
                                                            </li>
                                                        );
                                                    })
                                            ) : (
                                                <Empty
                                                    image={
                                                        "/th/img/promotions/non-promotion.png"
                                                    }
                                                    description={
                                                        <p>
                                                            ขณะนี้ไม่มีข้อเสนอใดๆ
                                                            {/* 暂时没有任何优惠 */}
                                                        </p>
                                                    }
                                                />
                                            )}
                                        </ul>
                                    </Spin>
                                    {filterdata && filterdata.length > 9 && (
                                        <Pagination
                                            className="custom-pagination"
                                            style={{
                                                textAlign: "left",
                                            }}
                                            defaultCurrent={1}
                                            pageSize={9}
                                            current={this.state.pageIndex}
                                            onChange={(e) => {
                                                console.log(typeof e);
                                                this.setState({
                                                    pageIndex: e,
                                                });
                                            }}
                                            total={filterdata.length}
                                            itemRender={(page, type, originalElement) => {
                                                if (type === "prev") {
                                                    return (
                                                        <img
                                                            src="/th/img/icon/gray-arrow.svg"
                                                            alt="left arrow"
                                                            style={{ transform: "rotate(-90deg)" }} // 左箭头
                                                        />
                                                    );
                                                }
                                                if (type === "next") {
                                                    return (
                                                        <img
                                                            src="/th/img/icon/gray-arrow.svg"
                                                            alt="right arrow"
                                                            style={{ transform: "rotate(90deg)" }} // 右箭头
                                                        />
                                                    );
                                                }
                                                return originalElement;
                                            }}
                                        />
                                    )}
                                </div>
                            </TabPane>
                        ))}
                    </Tabs>
                ) : (
                    <ul className="loading_card_list">
                        {[...Array(9)].map((item, index) => {
                            return (
                                <li key={index}>
                                    <div className="box">
                                        <div className="box_title" />
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                )}
                {/* 優惠詳情 Modal */}
                {isPromotionDetailModalVisible && (
                    <DetailModal
                        promotionInfo={{...selectedPromotionItem, ...selectedPromotionDetail}}
                        actionBtnHandler={(item, type) => {
                            this.actionBtnHandler(item, type);
                        }}
                        isLoading={
                            isRefreshingPromotion ||
                            isPromotionDetailLoading
                        }
                        isDetailVisible={isPromotionDetailModalVisible}
                        closeDetail={() => {
                            this.setState({
                                isPromotionDetailModalVisible: false,
                            });
                        }}
                        from="Promotion"
                    />
                )}
                {/* Manual 申請彈窗 */}
                {isManualApplyModalVisible && (
                    <ManualModal
                        promotionInfo={{...selectedPromotionItem, ...selectedPromotionDetail}}
                        memberInfo={this.props.memberInfo}
                        isVisible={isManualApplyModalVisible}
                        closeModal={() => {
                            this.setState({ isManualApplyModalVisible: false });
                        }}
                        onSuccess={() => {
                            this.setState({
                                isPromotionDetailModalVisible: false,
                            });
                            this.props.setPromotions(); //刷新 Promotion List
                        }}
                    />
                )}
                {/* Reload Bonus 申請彈窗 */}
                {isBonusModalVisible && (
                    <BonusModal
                        promotionInfo={{...selectedPromotionItem, ...selectedPromotionDetail}}
                        balanceInfo={balanceInfo}
                        isVisible={isBonusModalVisible}
                        closeModal={() => {
                            this.setState({ isBonusModalVisible: false });
                        }}
                        onSuccess={() => {
                            this.setState({
                                isPromotionDetailModalVisible: false,
                            });
                            this.props.setPromotions(); //刷新 Promotion List
                        }}
                    />
                )}
                {/* 開始優惠彈窗 */}
                {isStartModalVisible && (
                    <StartPromotionModal
                        visible={isStartModalVisible}
                        onClose={() => {
                            this.setState({
                                isStartModalVisible: false,
                                startPromotionData: null,
                            });
                        }}
                        selectedItem={startPromotionData}
                        onSuccess={() => {
                            this.setState({
                                isPromotionDetailModalVisible: false,
                            });
                        }}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        categories: state.promotion.categories,
        promotions: state.promotion.promotions,
        isRefreshingPromotion: state.promotion.isLoading,
        backPromotionPage: state.promotion.backPromotionPage,
        memberInfo: state.userCenter.memberInfo,
        balanceInfo: state.balance.balanceInfo,
        isBalanceLoading: state.balance.isBalanceLoading,
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        setSelectedBonus: (bonusItem) => {
            dispatch(promotionActions.setSelectedBonus(bonusItem));
        },
        setCategories: (result) => {
            dispatch(promotionActions.setCategories(result));
        },
        setPromotions: () => {
            dispatch(getPromotionListAction());
        },
        setBackPromotionPage: (status) => {
            dispatch(promotionActions.setBackPromotionPage(status));
        },
        getBalanceInfo: () => {
            dispatch(getBalanceInfoAction());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionTabs);
